import { useRef, useEffect, useState, useCallback } from 'react';

/**
 * Wraps a table with synchronized top + bottom horizontal scrollbars.
 * The top bar only appears when the table overflows the container.
 */
function DualScrollTable({ children }) {
    const topRef = useRef(null);
    const bottomRef = useRef(null);
    const [tableWidth, setTableWidth] = useState(0);
    const [isOverflowing, setIsOverflowing] = useState(false);

    const syncTop = useCallback(() => {
        if (bottomRef.current) bottomRef.current.scrollLeft = topRef.current.scrollLeft;
    }, []);

    const syncBottom = useCallback(() => {
        if (topRef.current) topRef.current.scrollLeft = bottomRef.current.scrollLeft;
    }, []);

    useEffect(() => {
        const container = bottomRef.current;
        if (!container) return;

        const update = () => {
            const table = container.querySelector('table');
            if (!table) return;
            const tw = table.scrollWidth;
            setTableWidth(tw);
            setIsOverflowing(tw > container.clientWidth);
        };

        update();

        const ro = new ResizeObserver(update);
        ro.observe(container);
        const table = container.querySelector('table');
        if (table) ro.observe(table);

        return () => ro.disconnect();
    }, [children]);

    return (
        <div className="dual-scroll-wrapper">
            {isOverflowing && (
                <div
                    ref={topRef}
                    className="dual-scroll-top"
                    onScroll={syncTop}
                >
                    <div style={{ width: tableWidth, height: 1 }} />
                </div>
            )}
            <div
                ref={bottomRef}
                className="dual-scroll-bottom"
                onScroll={syncBottom}
            >
                {children}
            </div>
        </div>
    );
}

export default DualScrollTable;
